__turbopack_context__.v({
  "cluster-pin": "style-module-scss-module__h4gvYW__cluster-pin",
  "container": "style-module-scss-module__h4gvYW__container",
  "dragging": "style-module-scss-module__h4gvYW__dragging",
  "marker": "style-module-scss-module__h4gvYW__marker",
  "marker-circle": "style-module-scss-module__h4gvYW__marker-circle",
  "marker-image": "style-module-scss-module__h4gvYW__marker-image",
  "marker-label": "style-module-scss-module__h4gvYW__marker-label",
  "placeholder": "style-module-scss-module__h4gvYW__placeholder",
  "pulse": "style-module-scss-module__h4gvYW__pulse",
});
